import UserManager from '../features/people/UserManager';

export default function UsersPage() {
  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1>Müşteri Hesapları</h1>
          <p>
            Müşteri kullanıcılarını yönetin, iletişim bilgilerini düzeltin ve gerektiğinde hesabı kalıcı olarak silin.
            E-posta değişikliklerinde yeniden doğrulama gerekir; sipariş geçmişi korunur.
          </p>
        </div>
      </header>
      <section className="page-section">
        <UserManager />
      </section>
    </div>
  );
}
